export default __webpack_public_path__ + "static/media/w_f_2023_a.2759e5d5.jpg";